export default __webpack_public_path__ + "static/invest-ee2a5fa179cd6f78603216e8bb81b3b5.jpg";